export const HeadingTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] as const;
export type HeadingTag = (typeof HeadingTags)[number];

export const HeadingLevels = ['giga', 'mega', 'epic', ...HeadingTags] as const;
export type HeadingLevel = (typeof HeadingLevels)[number];

export const HeadingSizes = ['sm', 'md', 'lg', 'xl', 'responsive'] as const;

export type HeadingSize = (typeof HeadingSizes)[number];
